import React, { useEffect, useRef, useState } from 'react';
import styles from '@/screens/Integration/Export/styles';
import Select from 'react-select';
import TMSCard from '@/components/IntegrationAutobook/TMSCard';
import LocalExcelCard from '@/components/IntegrationAutobook/LocalExcelCard';
import {
  adminChangeActiveExcelModeAutobook,
  adminGetExcelConfigsAutobook,
  adminGetSingleUser,
  adminSaveExcelConfigsAutobook,
  getAdminFinanceTrackingCompanies,
  SaveApiResMessage,
} from '@/actions';
import { useNotify } from 'react-admin';
import { Grid, Button, CircularProgress } from '@material-ui/core';
import SSLTable from '@/components/IntegrationExport/SSLTable';
import MTOTable from '@/components/IntegrationExport/MTOTable';
import SizeTable from '@/components/IntegrationAutobook/SizeTable';
import EmailCard from '@/components/IntegrationAutobook/EmailCard';
import ColumnsTable from '@/components/IntegrationExport/ColumnsTable';
import CityTable from '@/components/IntegrationExport/CityTable';
import SeparationTable from '@/components/IntegrationExport/SeparationTable';

export default () => {
  const cls = styles();
  const [pageContent, setPageContent] = useState({
    label: null,
    vlue: null,
  });
  const [companies, setCompanies] = useState([]);
  const [activeTms, setActiveTms] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [tmsType, setTmsType] = useState(null);
  const [tmsExcelMode, setTmsExcelMode] = useState(null);
  const [tablesData, setTablesData] = useState({});
  const [loadTables, setLoadTables] = useState(false);
  const [tableCities, setTableCities] = useState([]);
  const [tableSeprations, setTableSeprations] = useState([]);
  const [state, setState] = useState({
    DATA: {},
    loading: false,
  });
  const isMountedRef = useRef(false);

  const notify = useNotify();

  const pageContentOptions = [
    { label: 'TMS', value: 1 },
    { label: 'Excel And Goole Sheet', value: 3 },
    { label: 'Email', value: 4 },
    { label: 'Application', value: 5 },
  ];

  const getActiveExcelLabel = (value) => {
    switch (value) {
      case 1:
      case 2:
        return 'TMS';
      case 3:
        return 'Excel And Goole Sheet';
      case 4:
        return 'Email';
      case 5:
        return 'Application';
      default:
        return null;
    }
  };

  const getAutobookConfigFromUser = (user = {}) =>
    user?.excel_config_autobook || {};
  const getActiveModeAutobookData = (autobookConfig = {}) =>
    autobookConfig?.active_excel_mode_autobook_data ||
    autobookConfig?.excel_config_autobook_data ||
    {};

  const getExcelConfigAutobookTableData = (user = {}) => {
    const ac = user?.excel_config_autobook || {};
    return {
      ...getActiveModeAutobookData(ac),
      ...(user?.excel_config_autobook_data || {}),
      ...(user?.active_excel_mode_autobook_data || {}),
    };
  };

  const handleSelectCompany = (company) => {
    if (!company || !company.value) {
      localStorage.removeItem('company');
      setSelectedCompany(null);
      setTablesData({});
      setTableCities([]);
      setTableSeprations([]);
      setPageContent({ label: null, value: null });
      setTmsExcelMode(null);
      setTmsType(null);
      setLoadTables(false);
      return;
    }
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    localStorage.setItem('company', JSON.stringify(company));
    setSelectedCompany(company);
    setLoadTables(true);
    adminGetSingleUser(company.value)
      .then((data) => {
        if (!isMountedRef.current) return;
        const autobookConfig = getAutobookConfigFromUser(data);
        const activeModeData = getActiveModeAutobookData(autobookConfig);
        const activeExcelMode =
          activeModeData?.active_excel_mode ||
          autobookConfig?.active_excel_mode;
        setState({
          loading: false,
          DATA: data,
        });
        setPageContent({
          value: activeExcelMode,
          label: getActiveExcelLabel(activeExcelMode),
        });
        if (activeExcelMode === 1 || activeExcelMode === 2) {
          setTmsExcelMode({
            value: activeExcelMode === 1 ? 'FTP' : 'Email',
            label: activeExcelMode === 1 ? 'FTP' : 'Email',
          });
        }
        setActiveTms(
          activeModeData?.enable_ftp_integration ??
            autobookConfig.enable_ftp_integration ??
            data.enable_ftp_integration
        );
        if (company) {
          fetchTablesData(company.value);
        }
      })
      .catch((err) => {
        if (!isMountedRef.current) return;
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setState({
          DATA: {},
          loading: true,
        });
      });
  };

  const fetchTablesData = (company) => {
    const companyId = company || selectedCompany?.value;
    if (!companyId) {
      setLoadTables(false);
      setTablesData({});
      return;
    }
    setLoadTables(true);
    adminGetExcelConfigsAutobook(companyId)
      .then((data) => {
        if (!isMountedRef.current) return;
        setTablesData(data || {});
      })
      .catch(() => {
        if (!isMountedRef.current) return;
        setTablesData({});
      })
      .finally(() => {
        if (!isMountedRef.current) return;
        setLoadTables(false);
      });
  };

  const handleSaveExcelConfig = () => {
    let cities = {};
    tableCities.forEach((item) => {
      if (item.user && item.smart) {
        cities[item.user] = item.smart.value;
      }
    });
    let apiData = {
      ssl: tablesData.ssl,
      mtos: tablesData.mtos,
      size_type: tablesData.size_type,
      columns: tablesData.columns,
      cities,
      separations: tableSeprations,
    };
    adminSaveExcelConfigsAutobook(apiData, selectedCompany.value).then(
      (data) => {
        SaveApiResMessage({
          title: data?.messageHeader,
          message: 'update successfully',
          mode: 'success',
        });
      }
    );
  };

  const handleSelectIntegrationType = (item) => {
    setPageContent(item);
  };

  const handleChangeActiveExcelMode = (excelMode) => {
    if (!selectedCompany?.value) return;
    setLoadTables(true);
    adminChangeActiveExcelModeAutobook(selectedCompany.value, excelMode)
      .then((user) => {
        if (!isMountedRef.current || !user) return;
        const excelConfigAutobook = getAutobookConfigFromUser(user);
        const excelConfigAutobookData =
          getActiveModeAutobookData(excelConfigAutobook);
        const tableFromUser = getExcelConfigAutobookTableData(user);
        const tmsAutobookData = user?.tms_autobook_data || {};
        const activeExcelMode =
          tableFromUser?.active_excel_mode ||
          excelConfigAutobookData?.active_excel_mode ||
          excelConfigAutobook?.active_excel_mode;
        if (
          activeExcelMode === 3 ||
          activeExcelMode === 4 ||
          activeExcelMode === 5
        ) {
          setLoadTables(false);
          let adaptedCities = [];
          const citiesSource =
            tableFromUser.cities ||
            excelConfigAutobook.cities ||
            excelConfigAutobookData.cities;
          if (citiesSource) {
            Object.keys(citiesSource).forEach((key) => {
              const cityItem = citiesSource[key];
              if (!cityItem) return;
              adaptedCities.push({
                user: key,
                smart: {
                  value: cityItem,
                  label: cityItem?.city || '',
                },
              });
            });
          }
          setTableCities(adaptedCities);
          setTableSeprations(tableFromUser.separations || excelConfigAutobookData.separations || []);
          setTablesData({
            ...excelConfigAutobook,
            ...excelConfigAutobookData,
            ...tableFromUser,
          });
        } else if (activeExcelMode === 1 || activeExcelMode === 2) {
          setLoadTables(false);
          let adaptedCities = [];
          if (tmsAutobookData.cities) {
            Object.keys(tmsAutobookData.cities).forEach((key) => {
              const cityItem = tmsAutobookData.cities[key];
              if (!cityItem) return;
              adaptedCities.push({
                user: key,
                smart: {
                  value: cityItem,
                  label: cityItem?.city || '',
                },
              });
            });
          }
          setTableCities(adaptedCities);
          setTableSeprations(tableFromUser.separations || excelConfigAutobookData.separations || []);
          setTablesData({
            ...tableFromUser,
            ...(Object.keys(tmsAutobookData).length ? tmsAutobookData : {}),
          });
          if (user.tms_autobook_data) {
            const tms = user.tms_autobook_data;
            setTmsType({
              label: tms.name,
              value: tms.slug,
            });
          }
        } else {
          setTmsType(null);
        }
        fetchTablesData(selectedCompany.value);
      })
      .catch((err) => {
        if (!isMountedRef.current) return;
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoadTables(false);
      });
  };

  useEffect(() => {
    if (pageContent && pageContent.value) {
      setActiveTms(false);
      localStorage.setItem(
        'integration_autobook_type',
        JSON.stringify(pageContent)
      );
      handleChangeActiveExcelMode(pageContent.value);
    }
  }, [pageContent]);

  useEffect(() => {
    if (tmsExcelMode && tmsExcelMode.value) {
      let excelMode =
        tmsExcelMode.value === 'FTP'
          ? 1
          : tmsExcelMode.value === 'Email'
          ? 2
          : null;
      excelMode && handleChangeActiveExcelMode(excelMode);
    }
  }, [tmsExcelMode]);

  useEffect(() => {
    isMountedRef.current = true;
    getAdminFinanceTrackingCompanies().then((data) => {
      if (!isMountedRef.current) return;
      let companyData = [];
      data.forEach((item) => {
        companyData.push({
          value: item.id,
          label: item.company,
        });
      });
      setCompanies(companyData);
    });
    let integration_autobook_type = localStorage.getItem(
      'integration_autobook_type'
    );
    if (integration_autobook_type) {
      setPageContent(JSON.parse(integration_autobook_type));
    }
    let company = localStorage.getItem('company');
    if (company) {
      const parsedCompany = JSON.parse(company);
      if (parsedCompany && parsedCompany.value) {
        handleSelectCompany(parsedCompany);
      } else {
        localStorage.removeItem('company');
      }
    }
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return (
    <div className={cls.content}>
      <h2 className={cls.title}>Integration {'>'} Autobook</h2>
      <div className={cls.card}>
        <span className={cls.formDescription}>Select Company:</span>
        <div>
          <Select
            isClearable
            placeholder="Company"
            className={cls.select}
            defaultValue={selectedCompany}
            value={selectedCompany}
            onChange={(item) => {
              handleSelectCompany(item);
            }}
            options={companies}
          />
        </div>
      </div>
      {selectedCompany && (
        <div className={cls.card}>
          <span className={cls.formDescription}>Select Integration Type:</span>
          <div>
            <Select
              isClearable
              placeholder="Integration Type"
              className={cls.select}
              defaultValue={pageContent}
              value={pageContent}
              onChange={(item) => {
                handleSelectIntegrationType(item);
              }}
              options={pageContentOptions}
            />
          </div>
        </div>
      )}
      {(pageContent.value === 1 || pageContent.value === 2) && (
        <TMSCard
          notify={notify}
          setActiveTms={setActiveTms}
          activeTms={activeTms}
          selectedCompany={selectedCompany}
          state={state}
          tmsType={tmsType}
          setTmsType={setTmsType}
          tmsExcelMode={tmsExcelMode}
          setTmsExcelMode={setTmsExcelMode}
          fetchTablesData={fetchTablesData}
          excelConfigData={{
            ...getAutobookConfigFromUser(state.DATA),
            ...getActiveModeAutobookData(getAutobookConfigFromUser(state.DATA)),
            ...tablesData,
          }}
        />
      )}
      {pageContent.value === 3 && (
        <LocalExcelCard
          notify={notify}
          selectedCompany={selectedCompany}
          state={state}
          handleSelectCompany={handleSelectCompany}
          excelConfigData={{
            ...getAutobookConfigFromUser(state.DATA),
            ...getActiveModeAutobookData(getAutobookConfigFromUser(state.DATA)),
            ...tablesData,
          }}
        />
      )}
      {pageContent.value === 4 && (
        <EmailCard
          notify={notify}
          selectedCompany={selectedCompany}
          DATA={{
            ...getAutobookConfigFromUser(state.DATA),
            ...getActiveModeAutobookData(getAutobookConfigFromUser(state.DATA)),
            ...tablesData,
          }}
          handleSelectCompany={handleSelectCompany}
        />
      )}
      <>
        {loadTables ? (
          <div className={cls.loaderContainer}>
            <CircularProgress className={cls.loader} />
          </div>
        ) : (
          <>
            {selectedCompany &&
              ((pageContent &&
                tmsExcelMode &&
                pageContent.label === 'TMS' &&
                tmsExcelMode.value) ||
                pageContent.label !== 'TMS') && (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={12} lg={6}>
                      <SSLTable
                        tablesData={tablesData}
                        setTablesData={setTablesData}
                        pageContent={pageContent}
                      />
                    </Grid>

                    <Grid item xs={12} lg={6}>
                      <MTOTable
                        tablesData={tablesData}
                        setTablesData={setTablesData}
                        pageContent={pageContent}
                      />
                    </Grid>

                    <Grid className={cls.cityContainer} item xs={12} lg={6}>
                      <SizeTable
                        selectedCompany={selectedCompany}
                        tablesData={tablesData}
                        setTablesData={setTablesData}
                        pageContent={pageContent}
                      />
                      <CityTable
                        selectedCompany={selectedCompany}
                        tableCities={tableCities}
                        setTableCities={setTableCities}
                        pageContent={pageContent}
                      />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <ColumnsTable
                        tablesData={tablesData}
                        setTablesData={setTablesData}
                        pageContent={pageContent}
                      />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <SeparationTable
                        selectedCompany={selectedCompany}
                        tableSeprations={tableSeprations}
                        setTableSeprations={setTableSeprations}
                        pageContent={pageContent}
                      />
                    </Grid>
                  </Grid>
                  {pageContent.value !== 1 && pageContent.value !== 2 && (
                    <Button
                      className={cls.saveBtn}
                      onClick={() => handleSaveExcelConfig()}>
                      save
                    </Button>
                  )}
                </>
              )}
          </>
        )}
      </>
    </div>
  );
};
